{
  "settings": "Tetapan",
  "yourDigitalAssistant": "Pembantu Digital anda",
  "getStarted": "Mulakan",
  "login": "Log masuk",
  "loggingIn": "Log masuk ...",
  "darkMode": "Mod gelap",
  "clearHistory": "Kosongkan sejarah",
  "historyCleared": "Sejarah dibersihkan",
  "changeLanguage": "Bahasa",
  "termsAndConditions": "Syarat Penggunaan",
  "messagePlaceholder": "Taip mesej anda di sini ...",
  "messagePlaceholderDisabled": "Menaip dilumpuhkan ...",
  "feedbackTitle": "Nilaikan pengalaman anda",
  "feedbackPlaceholder": "Beritahu kami mengenainya (pilihan)",
  "feedbackSend": "Hantar",
  "feedbackClose": "Tutup",
  "sessionExpired": "Sesi anda telah tamat tempoh kerana tidak aktif.",
  "startNewSession": "Mulakan sesi baharu",
  "apiError": "Oops! Sesuatu telah berlaku. Kami sedang berusaha untuk membetulkannya secepat mungkin.",
  "apiErrorOffline": "Anda tidak disambungkan ke internet.",
  "tryAgain": "Cuba lagi",
  "startOver": "Mula semula",
  "chatEnded": "Sembang telah tamat.",
  "chatEndedThankYou": "Terima kasih kerana berbual dengan kami!",
  "closeChat": "Tutup",
  "startNewChat": "Sembang lagi",
  "humanTakeoverStarted": "Anda kini dipindahkan ke perkhidmatan pelanggan ...",
  "humanTakeoverQueued": "Menunggu untuk berhubung dengan ejen",
  "humanTakeoverAnAgent": "Ejen",
  "humanTakeoverAgentEntered": "memasuki perbualan",
  "humanTakeoverAgentLogout": "meninggalkan perbualan",
  "humanTakeoverTransfer": "Anda sedang dipindahkan ke ejen baharu",
  "humanTakeoverEnded": "Anda kini sedang bersembang dengan pembantu digital anda",
  "version": "Versi",
  "formIntroText": "Sila isi borang berikut untuk mula bersembang dengan kami.",
  "formFirstName": "Nama pertama",
  "formLastName": "Nama terakhir",
  "formName": "Nama",
  "formEmail": "E-mel",
  "formWrongEmail": "Sila berikan alamat e-mel yang sah.",
  "formPhone": "Telefon",
  "formShipmentId": "ID Penghantaran",
  "formQuestion": "Soalan anda",
  "formAccountNumber": "Nombor akaun (untuk Pelanggan Perniagaan)",
  "formAddress": "Alamat",
  "formPostcode": "Poskod",
  "formCity": "Bandar",
  "formCountry": "Negara",
  "formSubmitButton": "Mulakan sembang",
  "formEmptyFieldError": "Tidak dibenarkan kosong.",
  "formPhoneNumberValidationError": "Bukan nombor telefon yang sah.",
  "formInputIsBiggerThan50": "Mesti paling banyak 50 aksara.",
  "formInputIsBiggerThan100": "Mesti paling banyak 100 aksara.",
  "formInputIsBiggerThan2000": "Mesti paling banyak 2000 aksara.",
  "widgetEventOnline": "Mesej DA: Pengguna kembali dalam talian.",
  "widgetEventHidden": "Mesej DA: Widget disembunyikan.",
  "widgetEventVisible": "Mesej DA: Widget kelihatan.",
  "widgetEventVisibleMinimized": "Mesej DA: Widget boleh dilihat, tetapi diminimumkan.",
  "widgetEventMinimized": "Mesej DA: Widget diminimumkan.",
  "widgetEventMaximized": "Mesej DA: Widget dimaksimumkan.",
  "widgetEventSessionExpired": "Mesej DA: Sesi widget tamat tempoh.",
  "widgetEventHangupHuman": "Mesej DA: Pengguna menamatkan sesi pengambilalihan manusia.",
  "widgetEventUserTyping": "Mesej DA: Pengguna sedang menaip.",
  "fileTooLarge": "Anda Sedang Cuba Melampirkan Fail Terlalu Besar.",
  "tooManyDiles": "You Are Attempting To Attach Too Many Files.",
  "fileInvalidType": "Anda Sedang Cuba Melampirkan Terlalu Banyak Fail.",
  "attachmentsDropHere": "Turun di sini untuk memuat naik atau",
  "attachmentsBrowse": "Semak imbas Fail",
  "attachmentsExtenstionQuantity": "pdf atau imej (sehingga 10 fail)",
  "attachmentsSize": "sehingga 30 MB",
  "attachmentsFailedUploading": "Uploading Failed",
  "attachmentsUploading": "Muat naik Gagal...",
  "minimizeExpandText": "Sembang langsung dengan kami sekarang!",
  "popupWidgetNotificationMessage": "Anda menerima mesej baharu!",
  "tabWidgetNotificationMessage": "Mesej baru!",
  "datepickerSendButton": "Hantar"
}
